import moment from 'moment-timezone';

import {getFromLocalStorage} from '@famly/stat_ts-utils_local-storage';

export const TOKEN_REFRESH_TIMESTAMP_KEY = 'accessTokenRefreshTimestamp';
export const EXPECTED_EXPIRATION_TIMESTAMP_KEY = 'expectedExpirationTimestamp';
export const ACCESS_TOKEN_KEY = 'accessToken';

/**
 * Checks whether the access token has expired, based on the expiration timestamp stored in local storage.
 *
 * @returns `true` when the stored expiration timestamp is in the past; `false` otherwise — including when
 * the timestamp is missing or invalid, in which case the token is treated as not expired.
 */
export const isAccessTokenExpired = () => {
    const now = moment();
    const expectedExpirationTimestamp = getFromLocalStorage(EXPECTED_EXPIRATION_TIMESTAMP_KEY);
    const expectedExpirationMoment = moment(expectedExpirationTimestamp);
    return expectedExpirationMoment.isValid() ? now.isAfter(expectedExpirationMoment) : false;
};
